module.exports = __webpack_public_path__ + "static/media/competency.77ba6fcc.png";